<template>
  <div class="product-info-section flex items-center text-black-40">
    <template v-for="(item, index) in displayList" :key="item.sectionName">
      <component :is="item.component" />
      <span v-if="index !== displayList.length - 1" class="circle-divider" :class="twMerge('size-0.5 mx-1 bg-gray-40', props.circleDividerClass)" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { twMerge } from 'tailwind-merge'

import ProductAvgPriceRangeSymbol from '@/components/product/product-avg-price-range-symbol.vue'
import ProductRating from '@/components/product/product-rating.vue'

import { useAppStore } from '@/store/app'

import type { ProductSubInfoType } from '@/types/product'
import type { BranchData, FbranchEatigoListData } from '@/types/api'

interface Props {
  data: Nullable<FbranchEatigoListData & BranchData>
  productSubInfoDisplayOrder: ProductSubInfoType[]
  circleDividerClass?: HTMLAttributes['class']
}

const props = defineProps<Props>()

const { t } = useI18n()

const appStore = useAppStore()

const displayMap = computed<Record<ProductSubInfoType, { component: Component; show: boolean }>>(() => ({
  ratings: { component: h(ProductRating, { class: 'gap-0.5', ratings: props.data?.ratings }), show: !!props.data?.ratings },
  region: { component: h('p', { class: 'product-region' }, props.data?.region_tag?.name), show: !!props.data?.region_tag?.name },
  cuisine: { component: h('p', { class: 'product-cuisine' }, props.data?.cuisine_tags?.[0]?.name), show: !!props.data?.cuisine_tags?.[0]?.name },
  reservations: {
    component: h('p', { class: 'product-reservations truncate flex-1' }, t('card.reservation_count', { count: props.data?.reservations })),
    show: !!props.data?.reservations,
  },
  'price-range-symbol': { component: h(ProductAvgPriceRangeSymbol, { avgPriceRange: props.data?.avg_price_range || 0 }), show: true },
  distance: { component: h('p', { class: 'product-distance' }, props.data?.distance), show: appStore.isLocationAcquired && !!props.data?.distance },
}))
const displayList = computed(() => {
  return props.productSubInfoDisplayOrder.map(sectionName => ({ sectionName, ...displayMap.value[sectionName] })).filter(item => item.show)
})
</script>
